(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dayspan"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["dayspan", "vue"], factory);
	else if(typeof exports === 'object')
		exports["dayspan-vuetify"] = factory(require("dayspan"), require("vue"));
	else
		root["dayspan-vuetify"] = factory(root["dayspan"], root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_191__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition